/* eslint-disable @typescript-eslint/promise-function-async */
import { NavigationGuard } from '@core/guards/navigation.guard';
import { RoutePaths } from '@global/routePaths';

export const OfferRoutes = [
  {
    path: RoutePaths.NEW_QUOTATION.OFFER.route,
    title: 'TITLE.FULL_QUOTE',
    loadChildren: () => import('@pages/offer/offer.module').then(m => m.OfferPageModule),
    canActivate: [NavigationGuard],
  },
];
